<ng-container *ngIf="antwoordResultaat?.resultaat?.value">
  <div data-hj-suppress class="ols-summary-answer">{{antwoordResultaat.resultaat.value | date:'d MMMM yyyy'}}</div>
</ng-container>
